/**=========================================================
 * Module: upload-file.js
 * Upload File Controller
 =========================================================*/

App.controller('UploadFileController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$sce', '$element', 'ngDialog',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $sce, $element, ngDialog) {
    "use strict";

    $scope.fileUploadList = [];
    $scope.error = null;

    $scope.fileId = $scope.field.name + '_' + ($scope.form.model.id || $scope.form.model.tempId);
    $scope.t = new Date().getTime();
    $scope.uploaded = false;
    $scope.allowString = ($scope.field.allow || '').replace(/\|/g, ', ');

    

    $scope.uploadedFile = function(data, fileId){
        if(data && data.error){
            $scope.error = true;
        } else {
            $scope.error = false;
            D.save('file', { 
                entityType: data.entityType, 
                entityId: data.entityId, 
                field: data.field,
                type: data.type,
                size: data.size,
                bucket: data.bucket,
                url: data.bucket + '/' + data.url
            }).then(function(resp){
                if(resp.versions && fileId && !$scope.field.noOverwrittenAlert){
                    angular.element('#overwritten_'+fileId).css('display', 'block')
                }
                $timeout(function(){$scope.refresh(false, true);},200);
            }).catch(console.error)
        }
    }
                    

    $scope.removeFile = function(index){
        var file = $scope.fileUploadList[index];
        ngDialog.openConfirm({
                  template: 'confirmRemoveFileDialog',
                  className: 'ngdialog-theme-default'
                })
        .then(function (value) {
                D.remove('file', file.id).then(
                    function(){
                        $scope.fileUploadList.splice(index, 1);
                        $rootScope.$broadcast('$refreshFile', {
                        	entityId: ($scope.form.model.id || $scope.form.model.tempId),
                        	type:$scope.form.type,
                        	field:$scope.field.name,
                        	//files:response,
                        	deleted: true,
                        	form: $scope.form
                        	});
                        if($scope.$parent.$parent.field && $scope.$parent.$parent.field.onremove)
                            $scope.$parent.$parent.field.onremove();
                        angular.element('#uploaded_' + $scope.fileId).hide();
                    }
                ).catch(console.error);
            }, function (reason) {

            });
    };

    $scope.filesBatchAction = function(actionName, files){
        if(actionName == 'delete'){
              ngDialog.openConfirm({
                    template: 'confirmRemoveFileDialog',
                    className: 'ngdialog-theme-default'
                 })
              .then(function (value) {
                     var promises = [];
                     for(var i=0; i<files.length; i++){
                        if(files[i].selected){
                          promises.push(D.remove('file', files[i].id));
                        }
                     }
                     Promise.all(promises).then(
                          function(){
                            $scope.refresh();
                            $rootScope.$broadcast('$refreshFile', {
                            	entityId: ($scope.form.model.id || $scope.form.model.tempId),
                            	type:$scope.form.type,
                            	field:$scope.field.name,
                            	deleted: true,
                            	form: $scope.form
                            	});
                            if($scope.$parent.$parent.field && $scope.$parent.$parent.field.onremove)
                                 $scope.$parent.$parent.field.onremove();
                            angular.element('#uploaded_' + $scope.fileId).hide();
                          }
                     ).catch(console.error);
                }, function (reason) {
    
                });
       }
    }

    


    $scope.refresh = function(retry, fileSaved){
        var ext = $scope.field.allow ? '&extension=' + $scope.field.allow : ''
        if(fileSaved) {
            $scope.hasZip = false;
            //$scope.removeZip();
        } else {
            D.query('file', 'type=' + $scope.form.type + '&field=' + $scope.field.name + '.zip&entityId=' + ($scope.form.model.id || $scope.form.model.tempId) + ext).then(
                function(response){
                    $scope.checkedZip = true;
                    if(response.length==1){
                        $scope.hasZip = true;
                        $scope.zip = response[0];
                    }
                }
            ).catch(console.error);
        }
        

        D.query('file', 'type=' + $scope.form.type + '&field=' + $scope.field.name + '&entityId=' + ($scope.form.model.id || $scope.form.model.tempId) + ext, { cache: false }).then(
                function(response){
                    $scope.fileUploadList = response;
                    $scope.fileTotalSize = 0;
                    for(var i=0; i<response.length; i++){
                        $scope.fileTotalSize += response[i].size;
                    }

                    if(!$scope.$parent.$parent.files){
                        $scope.$parent.$parent.files = {};
                    }
                    $scope.$parent.$parent.files[$scope.field.name] = response;

                    if(fileSaved && $scope.$parent.$parent.field && $scope.$parent.$parent.field.onupload)
                    	$scope.$parent.$parent.field.onupload(response);

                    $rootScope.$broadcast('$refreshFile', {
                    	entityId: ($scope.form.model.id || $scope.form.model.tempId),
                    	type:$scope.form.type,
                    	field:$scope.field.name,
                    	files:response,
                    	form: $scope.form
                    	});

                    if(retry)
                        $timeout($scope.refresh, 1000);

                    /*$scope.safeApply = function(fn) {
                  	  var phase = $rootScope.$$phase;
                  	  if(phase == '$apply' || phase == '$digest') {
                  	    if(fn && (typeof(fn) === 'function')) {
                  	      fn();
                  	    }
                  	  } else {
                  	    this.$apply(fn);
                  	  }
                  	};
                    var fn = function(){};
                    $scope.safeApply(fn);
                    $timeout(function(){$scope.safeApply(fn);},1000);*/
                }
                
            ).catch(function(error){
                    //$scope.error = error;
                    if(retry)
                        $timeout($scope.refresh, 2000);
                });
    };
    $scope.refresh();

    /*$scope.$watch('fileUploadList', function(){
        
    })*/

    var timer = null;

    function TimeCtrl($scope, $timeout) {
        $scope.clock = "loading clock..."; // initialise the time variable
        $scope.tickInterval = 5000 //ms
    
        var tick = function() {
            $scope.refresh();
            
            
            timer = $timeout(tick, $scope.tickInterval); // reset the timer
        }
    
        // Start the timer
        timer = $timeout(tick, $scope.tickInterval);
    }
    //TimeCtrl($scope, $timeout);


    $scope.$on('$destroy', function iVeBeenDismissed() {
      $timeout.cancel(timer);
    });
  }
  ]);
